import { c } from '../../utils/tailwind-merge';
import { ChipProps } from './types';

export const Chip = ({ label, type, onClick, className }: ChipProps) => {
  return (
    <button
      type={type === 'button' ? 'button' : undefined}
      onClick={onClick}
      className={c(
        'text-gray-700 border-gray-400 hover:bg-gray-300 mx-1 cursor-pointer rounded-full border bg-white px-4 py-1 text-base font-medium shadow-sm',
        className || ''
      )}
    >
      {label}
    </button>
  );
};
